export enum VIPSeasonConstant {
  CURRENT = 'current',
  NEXT = 'next',
}

export type SeasonDates = {
  startsOn: string;
  endsOn: string;
};
